export const GET_LIST_COMMENTARY_HOME_REQUEST = 'GET_LIST_COMMENTARY_HOME_REQUEST';
export const GET_LIST_COMMENTARY_HOME_REDUCER = 'GET_LIST_COMMENTARY_HOME_REDUCER';
export const RESET_LIST_COMMENTARY_HOME_REDUCER = 'RESET_LIST_COMMENTARY_HOME_REDUCER';

export const GET_COMMENTARY_HOME_REQUEST = 'GET_COMMENTARY_HOME_REQUEST';

